import { Controller } from "@hotwired/stimulus"
import { Dropzone } from "dropzone";

// This is a simple transposition from legacy js. It could be rewritten in a
// more stimulus-y way.
// Connects to data-controller="cloudinary-direct-upload"
export default class extends Controller {
  connect() {
    var $dropZone, $uploadField, cloudinaryField, formData, ref, uploader, url

    Dropzone.autoDiscover = false

    $(function () {})

    if ($.fn.cloudinary_fileupload === void 0) {
      console.error("Failed to load cloudinary library")
    }

    if (Dropzone === void 0) {
      console.error("Failed to load Dropzone")
    }

    // // const dropzone = new Dropzone("div#myId", { url: "/file/post" });
    $dropZone = $("#dropzone-area")

    $uploadField = $(
      "input.cloudinary-fileupload[type=file]"
    ).cloudinary_fileupload()

    ref = $uploadField.data()
    url = ref.url
    formData = ref.formData
    cloudinaryField = ref.cloudinaryField

    uploader = new Dropzone($dropZone.get(0), {
      dictDefaultMessage: "Click or drop a video file here to upload",
      url: url,
      maxFilesize: 80,
      maxFiles: 1,
      maxfilesexceeded: function (file) {
        this.removeAllFiles()
        this.addFile(file)
      },
      uploadMultiple: false,
      acceptedFiles: ".mov,.mp4,.m4v",
      addRemoveLinks: true,
    })

    uploader.on("error", function (file, errorMessage, xhr) {
      console.error(errorMessage)
      $("[data-dz-errormessage]").text("There was an error uploading the file.")
      return drop.removeFile(file)
    })

    uploader.on("totaluploadprogress", function (progress) {
      return $("[data-dz-uploadprogress]").css(
        "width",
        Math.floor(progress) + "%"
      )
    })

    uploader.on("sending", function (file, xhr, data) {
      var key, results, value
      results = []
      for (key in formData) {
        value = formData[key]
        results.push(data.append(key, value))
      }
      return results
    })

    uploader.on("success", function (file, data) {
      var $video, upload_info
      data.path = [
        "v",
        data.version,
        "/",
        data.public_id,
        data.format ? "." + data.format : "",
      ].join("")
      upload_info =
        [data.resource_type, data.type, data.path].join("/") +
        "#" +
        data.signature
      $("<input />")
        .attr({
          type: "hidden",
          name: "animation[video_id]",
        })
        .val(upload_info)
        .insertBefore($uploadField)
      $video = $("<video />")
        .attr("data-dz-thumbnail", true)
        .attr("autoplay", true)
        .attr("loop", true)
        .attr("width", 200)
        .append($("<source />").attr("src", data.secure_url))
      $("[data-dz-thumbnail]").replaceWith($video)
    })
  }
}
